<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in list" :key="index"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "CustomerType",
    props: ["value"],
    watch: {
      value: {
        immediate: true,
        handler: function(value) {
          this.data = value;
        }

      },

    },
    data() {
      return {
        data: "",
        list: [{
            name: "公司",
            value: 1
          },
          {
            name: "个人",
            value: 0
          }
        ]
      }
    },
    methods: {
      handleChange(value) {
        this.data = value;
        this.$emit("input", value)
      }
    }
  }
</script>

<style scoped>

</style>
